 <template>
     <div class="bottom">
        &copy;2019 108hill-office &amp; residence. All rights reserved.
     </div>
 </template>
 
 <script>
     export default {
         
     }
 </script>
 
 <style lang="scss" scoped>

 .bottom{
    background-color: $color-main;
    color: #fff;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    @include mobile{
        font-size: 10px;
    }
 }
 </style>